import React, { FC } from 'react';

import { KeyTransactions } from 'components/tables/TransactionsTable/data';

import ConstructorTransForm from '../../ConstructorTransForm';

interface ConversionIncomingCardType {}
const ConversionIncomingCard: FC<ConversionIncomingCardType> = () => (
  <>
    <ConstructorTransForm types={[KeyTransactions.VALUE_DATE_TIME, KeyTransactions.COMMISSION]} />
    <ConstructorTransForm types={[KeyTransactions.RATE]} />
    <ConstructorTransForm types={[KeyTransactions.COMMENT]} />
  </>
);
export default ConversionIncomingCard;
